import React from 'react';
import { getGroupsList } from '../../../../models/groups';
import i18n from '../../../../i18n';
import { formatDate, formatDateDDMMYY } from '../../../../utils/common';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_STATUS, DELIVERY_STATUS } from '../../../../constants/status';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Select from 'react-select';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NoData from '../../../common/NoData';
import { NavLink } from 'react-router-dom';
import Dropdown from '../../../common/DropDown';
import {
  bulkApproveAuctions,
  bulkInvoiceAuctions,
  getAuctionCategories,
  getAuctions,
  updateInvoiceDate,
} from './services/auctionService';
import { apiUrl } from '../../../../constants/global';
import { getOrganizationList } from '../../../../models/organization';
import { BiddersList } from './components/BiddersList';
import { Check, Pencil } from 'lucide-react';
import { toast } from 'react-toastify';
import { getLoggedUser } from '../../../../state/user';
import { InvoiceDateModal } from './components/InvoiceDateModal';

const user = getLoggedUser();

export class AuctionsListNew extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        type: '',
        category: '',
        status: '',
        client: null,
        group: null,
      },
      categories: [],
      clients: [],
      groups: [],
      auctions: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
      showBidders: false,
      bidders: [],
      selectedAction: null,
      selectedRows: [],
      toggleCleared: false,
      processing: false,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      type: params.get('type') || null,
      category: params.get('category') || null,
      client: params.get('client') || null,
      group: params.get('group') || null,
      status: params.get('status') || '',
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, page, limit }, () => {
      this.getAllOrganization();
      this.getAllCategories();
      this.fetchAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async fetchAuctions() {
    this.setState({ isloading: true });
    let { limit, page } = this.state;
    let { startDate, endDate, type, category, client, group, status } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (type) q.type = type;
    if (category) q.category = category;
    if (client) q.client = client;
    if (group) q.group = group;
    if (status) q.status = status;

    // Update URL
    this.updateUrlQuery(q);

    try {
      const response = await getAuctions(q);
      if (response.success) {
        this.setState({
          auctions: response.data,
          total: response.meta.total,
        });
      }
    } catch (error) {
      console.error('Auction fetch failed:', error);
    } finally {
      this.setState({ isloading: false });
    }
  }

  async getAllCategories() {
    this.setState({ categoriesLoading: true });
    const response = await getAuctionCategories();
    if (response.success) {
      let data = response.data;
      const categories = data.map((item) => {
        return {
          value: item.id,
          label: item.category_name,
        };
      });
      this.setState({ categories });
      this.setState({ categoriesLoading: false });
    } else {
      this.setState({ categoriesLoading: false });
    }
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let data = response.data;
    const clients = data.map((item) => {
      return {
        value: item.id,
        label: item.organization_name,
      };
    });
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ grouploading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let data = response.data;
      const groups = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ groups, groupLoading: false });
    } else {
      this.setState({ groups: [], grouploading: false });
    }
  }

  // Get action counts
  getActionCounts = () => {
    const { auctions, selectedRows } = this.state;
    return {
      approve: auctions.filter((a) => a.status === 'E' || a.status === 'N').length,
      invoice: auctions.filter((a) => a.status === 'E').length,
      selectedItems: selectedRows.length,
    };
  };

  // Check if row can be selected based on action
  isRowSelectable = (row) => {
    const { selectedAction } = this.state;
    if (!selectedAction) return false;

    if (selectedAction === 'approve') {
      return row.status === 'E' || row.status === 'N';
    }
    if (selectedAction === 'invoice_en' || selectedAction === 'invoice_ar') {
      return row.status === 'E' && ![1, 3].includes(row.delivery_status);
    }
    return false;
  };

  // Handle action selection
  handleActionChange = (action) => {
    this.setState({
      selectedAction: this.state.selectedAction === action ? null : action,
      selectedRows: [],
      toggleCleared: !this.state.toggleCleared,
    });
  };

  // Handle row selection
  handleRowSelected = (state) => {
    const selectedIds = state.selectedRows.map((row) => row.id);
    this.setState({
      selectedRows: selectedIds,
    });
  };

  // Handle confirmation
  handleConfirmation = async (type) => {
    const { selectedAction, selectedRows } = this.state;

    if (type === 'approve') {
      if (!selectedAction || selectedRows.length === 0) {
        toast.error('Please select at least one auction and an action.');
        return;
      }

      this.setState({ processing: true });

      try {
        let payload = {};
        let result = null;

        if (selectedAction === 'approve') {
          payload = { status: 'A', auctions_id: selectedRows };
          result = await bulkApproveAuctions(payload);
        } else if (selectedAction === 'invoice_en') {
          payload = { lang: 'en', auctions_id: selectedRows };
          result = await bulkInvoiceAuctions(payload);
        } else if (selectedAction === 'invoice_ar') {
          payload = { lang: 'ar', auctions_id: selectedRows };
          result = await bulkInvoiceAuctions(payload);
        }

        if (result?.success) {
          toast.success(`Successfully processed ${selectedRows.length} auctions.`);
        } else {
          toast.error(result?.message || 'Something went wrong.');
        }

        // Reset state and refresh after success
        this.setState({
          selectedRows: [],
          selectedAction: null,
          toggleCleared: !this.state.toggleCleared,
        });

        this.fetchAuctions();
      } catch (error) {
        console.error('Bulk action failed:', error);
        toast.error('Failed to process bulk action. Please try again.');
      } finally {
        // Always turn off the processing spinner
        this.setState({ processing: false });
      }
    } else {
      // Cancel action
      this.setState({
        selectedRows: [],
        selectedAction: null,
        toggleCleared: !this.state.toggleCleared,
      });
    }
  };

  getColumns = () => {
    const isClient = user?.role === 'C';
    const isAdmin = user?.role === 'A';
    const canViewBidCount = ['A', 'PM', 'OM', 'GM', 'CE', 'M'].includes(user?.role);
    const editInvoiceDate = ['A', 'PM', 'OM', 'F'].includes(user?.role);
    return [
      {
        id: 1,
        name: 'MZAD ID',
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => <span className="highlight-table-value">MZAD {row.id}</span>,
      },
      // ACTION COLUMN (hide for role C)
      ...(isAdmin
        ? [
            {
              id: 2,
              name: i18n.t('action'),
              width: '110px',
              wrap: true,
              center: true,
              cell: (row) => {
                const detailPath = `/edit_auction/${row.id}`;
                return (
                  <div className="action-buttons">
                    <ActionButton key="edit" label="edit" to={detailPath} />
                  </div>
                );
              },
            },
          ]
        : []),
      ...(canViewBidCount
        ? [
            {
              id: 3,
              name: i18n.t('bid_count'),
              width: '110px',
              sortable: true,
              wrap: true,
              cell: (row) => (
                <button
                  className="button1 button1-outline button1-action"
                  disabled={row.bidders_count <= 0}
                  onClick={() => {
                    this.setState({
                      showBidders: true,
                      bidders: row.bidders,
                    });
                  }}
                >
                  {row.bidders_count}
                </button>
              ),
            },
          ]
        : []),

      {
        id: 4,
        name: i18n.t('title'),
        width: '140px',
        cell: (row) => <span className="highlight-table-value-secondary">{row.title}</span>,
      },
      {
        id: 5,
        name: i18n.t('price'),
        width: '90px',
        cell: (row) => <span>{row.start_amount}</span>,
        wrap: true,
        right: true,
      },
      {
        id: 6,
        name: i18n.t('increment_amount'),
        width: '100px',
        cell: (row) => <span>{row.bid_increment}</span>,
        wrap: true,
        right: true,
      },
      {
        id: 7,
        name: i18n.t('start_date'),
        width: '120px',
        cell: (row) => <span>{formatDate(row.start_date)}</span>,
        wrap: true,
      },
      {
        id: 8,
        name: i18n.t('end_date'),
        width: '120px',
        cell: (row) => <span>{formatDate(row.end_date)}</span>,
        wrap: true,
      },
      {
        id: 9,
        name: i18n.t('status'),
        width: '100px',
        cell: (row) => <StatusBadge status={AUCTION_STATUS[row.status]} />,
        wrap: true,
      },
      {
        id: 10,
        name: i18n.t('delivery_status'),
        width: '140px',
        cell: (row) => <StatusBadge status={DELIVERY_STATUS[row.delivery_status]} />,
        wrap: true,
      },
      {
        id: 11,
        name: i18n.t('client_approved'),
        width: '140px',
        cell: (row) =>
          row.client_approved_at ? (
            <span>{formatDate(row.client_approved_at)}</span>
          ) : (
            <span className="attachment-empty">{i18n.t('no_data')}</span>
          ),
        wrap: true,
      },
      ...(editInvoiceDate
        ? [
            {
              id: 12,
              name: i18n.t('invoice_date'),
              width: '160px',
              cell: (row) => (
                <div className="invoice-date-cell">
                  {row.invoice_date ? (
                    <span>{formatDateDDMMYY(row.invoice_date)}</span>
                  ) : (
                    <span className="attachment-empty">{i18n.t('no_data')}</span>
                  )}
                  {![1, 3].includes(row.delivery_status) && row.status === 'E' && (
                    <button
                      type="button"
                      className="btn-icon-edit"
                      title={i18n.t('edit_invoice_date')}
                      onClick={() => this.handleOpenInvoiceDateModal(row)}
                    >
                      <Pencil size={14} strokeWidth={1.5} />
                    </button>
                  )}
                </div>
              ),
              wrap: true,
            },
          ]
        : []),
      // BIDDER INVOICE COLUMN (hide for role C)
      ...(!isClient
        ? [
            {
              id: 13,
              name: `${i18n.t('invoice')} ${i18n.t('bidder')}`,
              button: true,
              width: '120px',
              wrap: true,
              cell: (row) =>
                ![1, 3].includes(row.delivery_status) && row.status === 'E' ? (
                  <div>
                    <a
                      className="btn-new btn-new--action-b"
                      href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=ar&auction=${row.id}`}
                      target="_new"
                    >
                      {i18n.t('Ar')}
                    </a>
                    &nbsp;
                    <a
                      className="btn-new btn-new--action-b"
                      href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=en&auction=${row.id}`}
                      target="_new"
                    >
                      {i18n.t('En')}
                    </a>
                  </div>
                ) : (
                  <span className="attachment-empty">{i18n.t('auction_approval_required')}</span>
                ),
            },
          ]
        : []),

      // CLIENT INVOICE COLUMN (hide for role C)
      ...(!isClient
        ? [
            {
              id: 14,
              name: `${i18n.t('invoice')} ${i18n.t('client')}`,
              button: true,
              width: '120px',
              wrap: true,
              cell: (row) =>
                ![1, 3].includes(row.delivery_status) && row.status === 'E' ? (
                  <div>
                    <a
                      className="btn-new btn-new--action-c"
                      href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=ar&is_client=1&auction=${row.id}`}
                      target="_new"
                    >
                      {i18n.t('Ar')}
                    </a>
                    &nbsp;
                    <a
                      className="btn-new btn-new--action-c"
                      href={`${apiUrl}my_winnings/pdf?id=${row.winner?.user_id}&group=${row.group}&lang=en&is_client=1&auction=${row.id}`}
                      target="_new"
                    >
                      {i18n.t('En')}
                    </a>
                  </div>
                ) : (
                  <span className="attachment-empty">{i18n.t('auction_approval_required')}</span>
                ),
            },
          ]
        : []),
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          // Only load if client has value
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.fetchAuctions();
  };

  handleClear = () => {
    const defaultSearch = {
      startDate: null,
      endDate: null,
      type: '',
      category: '',
      status: '',
      client: null,
      group: null,
    };

    this.setState({ search: defaultSearch, page: 1, selectedRows: [] }, () => {
      this.fetchAuctions();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.fetchAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.fetchAuctions();
    });
  };

  handleOpenInvoiceDateModal = (row) => {
    this.setState({ showInvoiceDateModal: true, selectedAuctionForInvoice: row });
  };

  handleCloseInvoiceDateModal = () => {
    if (this.state.savingInvoiceDate) return;
    this.setState({ showInvoiceDateModal: false, selectedAuctionForInvoice: null });
  };

  handleSaveInvoiceDate = async (newDate) => {
    const { selectedAuctionForInvoice } = this.state;
    if (!selectedAuctionForInvoice) return;

    this.setState({ savingInvoiceDate: true });
    try {
      const response = await updateInvoiceDate({
        id: selectedAuctionForInvoice.id,
        date: newDate,
      });

      if (response?.success) {
        toast.success(response?.message || i18n.t('invoice_date_updated_successfully'));
        this.setState({ showInvoiceDateModal: false, selectedAuctionForInvoice: null });
        this.fetchAuctions();
      } else {
        toast.error(
          response?.message || i18n.t('An error occurred while updating the invoice date')
        );
      }
    } catch (error) {
      console.error('Update invoice date failed:', error);
      toast.error(i18n.t('An error occurred while updating the invoice date'));
    } finally {
      this.setState({ savingInvoiceDate: false });
    }
  };

  // Shared filters + table, reused by both the client layout and the internal (sidebar) layout
  renderListContent() {
    const { groups, auctions, clients, categories, selectedAction, processing } = this.state;
    const actionCounts = this.getActionCounts();
    const isClient = user?.role === 'C';

    return (
      <>
        <FilterSection
          loading={this.state.isloading}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        >
          {/* Start Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="startDate"
              type="date"
              name="startDate"
              value={this.state.search.startDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder=" " // Important: single space for floating effect
            />
            <label htmlFor="startDate" className="floating-label">
              {i18n.t('start_date')}
            </label>
          </div>

          {/* End Date */}
          <div className="select-wrapper floating-label-wrapper">
            <input
              id="endDate"
              type="date"
              name="endDate"
              value={this.state.search.endDate || ''}
              onChange={this.handleSearchChange}
              className="filter-base floating-input"
              placeholder={i18n.t('end_date')}
            />
            <label htmlFor="endDate" className="floating-label">
              {i18n.t('end_date')}
            </label>
          </div>

          {/* Type  Dropdown */}
          <Dropdown
            name="type"
            value={this.state.search.type}
            onChange={this.handleSearchChange}
            placeholder={i18n.t('auction_type')}
            empty={i18n.t('select_type')}
            options={[
              { value: 'active', label: i18n.t('active') },
              { value: 'previous', label: i18n.t('previous') },
              { value: 'upcoming', label: i18n.t('upcoming') },
              { value: 'direct', label: i18n.t('direct') },
            ]}
          />

          {/* Category Type Dropdown */}
          <Dropdown
            name="category"
            value={this.state.search.category}
            onChange={this.handleSearchChange}
            placeholder={i18n.t('category')}
            empty={i18n.t('select_category')}
            options={categories}
          />
          {!isClient && (
            <>
              {/* Client Dropdown */}
              <div className="react-select-wrapper">
                <Select
                  options={clients}
                  value={clients.find((c) => c.value === this.state.search.client) || null}
                  onChange={(selectedOption) => {
                    const clientValue = selectedOption ? selectedOption.value : null;
                    this.setState(
                      (prevState) => ({
                        search: {
                          ...prevState.search,
                          client: clientValue,
                          group: null,
                        },
                        groups: [],
                      }),
                      () => {
                        if (clientValue) {
                          this.getAllGroups();
                        }
                      }
                    );
                  }}
                  name="client"
                  styles={selectStyles}
                  menuPlacement="auto"
                  menuPortalTarget={document.body}
                  placeholder={i18n.t('select_client')}
                  className=""
                />
                {/* Only show label when there's a selected value */}

                <label className="react-select-label">{i18n.t('client_name')}</label>
              </div>

              {/* Group Dropdown */}
              <div className="react-select-wrapper">
                <Select
                  options={groups}
                  value={groups.find((c) => c.value === this.state.search.group) || null}
                  onChange={(selectedOption) => {
                    this.setState((prevState) => ({
                      search: {
                        ...prevState.search,
                        group: selectedOption ? selectedOption.value : null,
                      },
                    }));
                  }}
                  name="group"
                  styles={selectStyles}
                  menuPlacement="auto"
                  menuPortalTarget={document.body}
                  placeholder={i18n.t('search_group')}
                  isLoading={this.state.groupLoading}
                  isDisabled={this.state.groupLoading}
                  //   noOptionsMessage={() => i18n.t('no_groups_found')}
                  className=""
                />
                {/* Only show label when there's a selected value */}

                <label className="react-select-label">{i18n.t('group')}</label>
              </div>
            </>
          )}
        </FilterSection>
        {!isClient && (
          <>
            {/* Bulk Action Selector */}
            <ActionSelector
              role={user?.role}
              selectedAction={selectedAction}
              onActionChange={this.handleActionChange}
              actionCounts={actionCounts}
              onProceed={() => this.handleConfirmation('approve')}
              onCancel={() => this.handleConfirmation('cancel')}
              loading={processing}
            />
          </>
        )}

        <div className="Data-Listing">
          {this.state.isloading ? (
            <TableSkeleton columns={10} rows={10} />
          ) : this.state.auctions.length ? (
            <DataTable
              responsive={true}
              columns={this.getColumns()}
              data={auctions}
              customStyles={tableStyles}
              highlightOnHover
              selectableRows={selectedAction !== null}
              selectableRowsHighlight
              selectableRowDisabled={(row) => !this.isRowSelectable(row)}
              onSelectedRowsChange={this.handleRowSelected}
              clearSelectedRows={this.state.toggleCleared}
              pagination
              paginationServer
              paginationTotalRows={this.state.total}
              paginationPerPage={this.state.limit}
              paginationDefaultPage={this.state.page}
              paginationRowsPerPageOptions={[15, 25, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: i18n.t('rows_per_page'),
                rangeSeparatorText: i18n.t('out'),
              }}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          ) : (
            <NoData
              message={i18n.t('no_auctions_available')}
              actionText={i18n.t('refresh')}
              onAction={this.fetchAuctions.bind(this)}
            />
          )}
        </div>
      </>
    );
  }

  render() {
    const {
      showBidders,
      bidders,
      showInvoiceDateModal,
      selectedAuctionForInvoice,
      savingInvoiceDate,
    } = this.state;
    const isClient = user?.role === 'C';

    const modals = (
      <>
        <BiddersList
          show={showBidders}
          bidders={bidders}
          onClose={() => this.setState({ showBidders: false })}
        />
        <InvoiceDateModal
          show={showInvoiceDateModal}
          auction={selectedAuctionForInvoice}
          onClose={this.handleCloseInvoiceDateModal}
          onSave={this.handleSaveInvoiceDate}
          loading={savingInvoiceDate}
        />
      </>
    );

    if (isClient) {
      return (
        <React.Fragment>
          <div className="cd-page">
            <div className="cd-shell">
              <p className="cd-crumb">
                <NavLink to="/client-management">{i18n.t('dashboard')}</NavLink>
                <span className="cd-crumb__current">{i18n.t('auctions')}</span>
              </p>

              <header className="cd-hero cd-hero--compact">
                <h1 className="cd-hero__title">{i18n.t('auctions')}</h1>
                <p className="cd-hero__sub">
                  {i18n.t('manage_auctions_bidders_and_financial_records')}
                </p>
              </header>

              <div className="card">
                <div className="card-body">{this.renderListContent()}</div>
              </div>
            </div>
          </div>
          {modals}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('auctions')}
          subtitle={i18n.t('manage_auctions_bidders_and_financial_records')}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">{this.renderListContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {modals}
      </React.Fragment>
    );
  }
}

const ActionButton = ({
  label,
  icon,
  to,
  variant = 'button1-primary',
  onClick,
  active = false,
}) => {
  if (to) {
    return (
      <NavLink to={to} className={`button1 ${variant} button1-action`}>
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button
      disabled={active}
      className={`button1 button1-primary button1-action`}
      onClick={onClick}
    >
      {icon} {i18n.t(label)}
    </button>
  );
};

const ActionSelector = ({
  role,
  selectedAction,
  onActionChange,
  actionCounts,
  onProceed,
  onCancel,
  loading,
}) => {
  const canApprove = ['A'].includes(role);
  const actions = [
    ...(canApprove
      ? [
          {
            id: 'approve',
            label: i18n.t('approve'),
            count: actionCounts.approve,
          },
        ]
      : []),

    {
      id: 'invoice_en',
      label: `${i18n.t('invoice')} ${i18n.t('En')}`,
      count: actionCounts.invoice,
    },
    {
      id: 'invoice_ar',
      label: `${i18n.t('invoice')} ${i18n.t('Ar')}`,
      count: actionCounts.invoice,
    },
  ];

  return (
    <div className="bulk-action-selector">
      <div className="action-title">{i18n.t('select_bulk_action')}</div>

      <div className="action-content">
        <div className="action-buttons">
          {actions.map((action) => {
            const isActive = selectedAction === action.id;
            const isDisabled = action.count === 0;
            return (
              <button
                key={action.id}
                onClick={() => onActionChange(action.id)}
                className={`action-select-btn ${isActive ? 'active' : ''}`}
                disabled={isDisabled}
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  opacity: isDisabled ? 0.6 : 1,
                }}
              >
                <span className="radio-icon">
                  {isActive ? <Check size={14} strokeWidth={3} /> : null}
                </span>
                <span className="action-label">{action.label}</span>
                {/* <span className="action-count">{action.count}</span> */}
              </button>
            );
          })}
        </div>

        <div className="action-controls">
          <button
            className="button1 button1-gray"
            onClick={onCancel}
            disabled={!selectedAction || loading}
          >
            {i18n.t('cancel')}
          </button>
          <button
            className="button1 button1-primary"
            onClick={onProceed}
            disabled={!actionCounts.selectedItems || loading}
          >
            {loading ? (
              <>
                {i18n.t('process')}
                <span className="spinner" />
              </>
            ) : (
              <>
                {i18n.t('process')}
                <span className="action-count">{actionCounts.selectedItems}</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
